import { render, staticRenderFns } from "./WSReportContainer.vue?vue&type=template&id=68384464&"
import script from "./WSReportContainer.vue?vue&type=script&lang=js&"
export * from "./WSReportContainer.vue?vue&type=script&lang=js&"
import style0 from "./WSReportContainer.vue?vue&type=style&index=0&id=68384464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports